<!-- Request Spreadsheet Submissions table component -->
<template>
	<ApiErrorAlert v-if="error" :error="error" />
	<div v-else-if="list.length" class="card">
		<div class="card-body">
			<h4 class="header-title mb-2">
				{{ $t('Place Order.heading_uploaded') }}
			</h4>
			<div v-if="loading" class="loading-state text-center m-auto">
				<div
					class="spinner-border avatar-lg text-primary"
					role="status"
				/>
			</div>
			<div v-else class="table-responsive mb-0">
				<table
					class="table table-centered table-nowrap table-hover mb-0 mt-2"
				>
					<thead>
						<tr>
							<th>
								{{ $t('Place Order.table_header_file_name') }}
							</th>
							<th>
								{{ $t('Place Order.table_header_created_at') }}
							</th>
							<th>
								{{
									$t(
										'Place Order.table_header_deliveries_requested'
									)
								}}
							</th>
							<th>
								{{
									$t(
										'Place Order.table_header_deliveries_edited'
									)
								}}
							</th>
							<th>
								{{ $t('Place Order.table_header_download') }}
							</th>
							<th>
								{{
									$t(
										'Place Order.table_header_first_mile_label_download'
									)
								}}
							</th>
							<th>
								{{
									$t(
										'Place Order.table_header_last_mile_label_download'
									)
								}}
							</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="item of list">
							<tr :key="item.id">
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{ item.fileName }}
									</h5>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{
											displayDatetime(
												item.createdAt,
												$t('Datetime.time_24')
											)
										}}
									</h5>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{
											displayDatetime(
												item.createdAt,
												$t('Datetime.date_full')
											)
										}}
									</h5>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{ item.createdRequestsNum }}
									</h5>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{ item.updatedRequestsNum }}
									</h5>
								</td>
								<td class="table-action text-center">
									<a
										:href="item.fileUrl"
										class="action-icon"
										target="_blank"
									>
										<i class="mdi mdi-download" />
									</a>
								</td>
								<td class="table-action text-center">
									<a
										v-if="
											hasKey(
												item,
												'labelPdfUrls.FIRST_MILE'
											)
										"
										:href="item.labelPdfUrls.FIRST_MILE"
										class="action-icon"
										target="_blank"
									>
										<i class="mdi mdi-download" />
									</a>
								</td>
								<td class="table-action text-center">
									<a
										v-if="
											hasKey(
												item,
												'labelPdfUrls.LAST_MILE'
											)
										"
										:href="item.labelPdfUrls.LAST_MILE"
										class="action-icon"
										target="_blank"
									>
										<i class="mdi mdi-download" />
									</a>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import ApiErrorAlert from '@/components/ApiErrorAlert.vue'
import {
	spreadsheetSubmissionsComputed,
	spreadsheetSubmissionsMethods
} from '@/store/helpers'
import { displayDatetime } from '@/utils/helpers'
import _ from 'lodash'

export default {
	components: { ApiErrorAlert },
	i18nOptions: { keyPrefix: 'PORTAL' },
	computed: {
		...spreadsheetSubmissionsComputed
	},
	mounted() {
		this.fetchSpreadsheetSubmissions()
	},
	methods: {
		...spreadsheetSubmissionsMethods,
		displayDatetime,
		hasKey(obj, key) {
			return _.has(obj, key)
		}
	}
}
</script>

<style scoped></style>
